import { render, staticRenderFns } from "./extraInfoBlocks.vue?vue&type=template&id=ef8afe70&"
import script from "./extraInfoBlocks.vue?vue&type=script&lang=js&"
export * from "./extraInfoBlocks.vue?vue&type=script&lang=js&"
import style0 from "./extraInfoBlocks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardSubtitle,VCardText,VIcon})
